<template>
  <div class="container">
    <div class="lucky-wheel">
      <header>
        <span>活动累计原力</span>
        <div>112</div>
      </header>
      <div class="wheel-main">
        <div class="wheel-pointer" @click="beginRotate()"></div>
        <div class="wheel-bg" :style="rotateStyle">
          <div class="prize-list">
            <div
              class="prize-item"
              v-for="(item, index) in prizeList"
              :key="index"
              :style="item.style"
            >
              <div class="prize-pic">
                <img :src="item.icon" />
              </div>
              <div class="prize-type">{{ item.name }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <main>
      <div class="main-header">
        <img src="@/assets/img/618activity.png" />
        活动规则
        <img src="@/assets/img/618activity.png" />
      </div>
      <div class="main-content">
        <p>
          1.凡在活动期间 6.1-6.20日，在商城中购买好物聚商品每满219
          原力，即可参与一次抽奖
        </p>
        <p>2.抽奖次数不限制，只要达到原力达到 219即可参与，可累计。</p>
        <p>
          3.在商品支付后，达到原力的提醒用户直接去抽奖，实物需要姓名电话和地址，若是原子市直接在购买账号到账。所有奖品跟对应订单统一解锁，若期间出现退单该此抽奖无效(质量问题除外)。
        </p>
        <p>
          4.活动消耗原力非真实消耗，只是活动期间满足条件后免费赠予您抽奖机会。
        </p>
        <p>5.有问题请联系客服。</p>
      </div>
    </main>
    <div @click="showPopup">展示弹出层</div>

    <van-popup v-model="show" >
      <div class="popup-box">
        <div class="popup-text">
          恭喜您!<br />
          抽中XX奖
        </div>
        <div class="popup-button">
          <img src="@/assets/img/618chakan.png" alt="">
        </div>
        <img src="@/assets/img/618poup.png" alt="" />

      </div>
      <div class="popup-close" @click="show=false">
          <img src="@/assets/img/618close.png" alt="">
        </div>
    </van-popup>

    <!--   
       
     

  @delete="onDelete"
   -->
    <van-popup v-model="showTake" round position="bottom" :style="{ height: '45%' }" >
      <van-address-edit
      :area-list="areaList"
      @save="onSave"
  show-search-result
  save-button-text="确认" 
  :area-columns-placeholder="['请选择', '请选择', '请选择']"

/>
    </van-popup>
  </div>
</template>
<script>
import { Toast } from 'vant';
import { areaList } from '@vant/area-data';
import { prizeList } from "./config";
const CIRCLE_ANGLE = 360;

const config = {
  // 总旋转时间
  duration: 4000,
  // 旋转圈数
  circle: 8,
  mode: "ease-in-out",
};

export default {
  data() {
    return {
      areaList,
      count: 10, // 剩余抽奖次数
      duration: 3000, // 转盘旋转时间
      prizeList: [], // 奖品列表
      rotateAngle: 0, // 旋转角度
      index: 0,
      prize: null,

      //弹出层
      show: false,
      //收货
      showTake:false
    };
  },
  created() {
    // 初始化一些值
    this.angleList = [];
    // 是否正在旋转
    this.isRotating = false;
    // 基本配置
    this.config = config;

    // 获取奖品列表
    this.initPrizeList();
  },
  computed: {
    rotateStyle() {
      return `
        -webkit-transition: transform ${this.config.duration}ms ${this.config.mode};
        transition: transform ${this.config.duration}ms ${this.config.mode};
        -webkit-transform: rotate(${this.rotateAngle}deg);
            transform: rotate(${this.rotateAngle}deg);`;
    },
    toastTitle() {
      return this.prize && this.prize.isPrize === 1
        ? "恭喜您，获得" + this.prize.name
        : "未中奖";
    },
    toastIcon() {
      return this.prize && this.prize.isPrize === 1
        ? require("../assets/img/congratulation.png")
        : require("../assets/img/sorry.png");
    },
  },
  methods: {
    onSave(val) {
      console.log(val)
      Toast('save');
    },


    showPopup() {
      this.showTake = true;
    },
    initPrizeList() {
      // 这里可以发起请求，从服务端获取奖品列表
      // 这里使用模拟数据

      this.prizeList = this.formatPrizeList(prizeList);
    },
    // 格式化奖品列表，计算每个奖品的位置
    formatPrizeList(list) {
      // 记录每个奖的位置
      const angleList = [];

      const l = list.length;
      // 计算单个奖项所占的角度
      const average = CIRCLE_ANGLE / l;
      console.log(average, "average");

      const half = average / 2;

      // 循环计算给每个奖项添加style属性
      list.forEach((item, i) => {
        // 每个奖项旋转的位置为 当前 i * 平均值 + 平均值 / 2
        const angle = -(i * average + half);
        // 增加 style
        item.style = `-webkit-transform: rotate(${angle}deg);
                      transform: rotate(${angle}deg);`;

        // 记录每个奖项的角度范围
        angleList.push(i * average + half);
      });

      this.angleList = angleList;
      console.log(angleList, "angleList");

      return list;
    },
    beginRotate() {
      // 添加次数校验

      if (this.count === 0) return;

      // 开始抽奖
      // 这里这里向服务端发起请求，得到要获得的奖
      // 可以返回下标，也可以返回奖品 id，通过查询 奖品列表，最终得到下标

      // 随机获取下标
      this.index = this.random(this.prizeList.length - 1);
      console.log(this.index,'111111')

      // 减少剩余抽奖次数
      this.count--;

      // 开始旋转
      this.rotating();
    },
    random(max, min = 0) {
      return parseInt(Math.random() * (max - min + 1) + min);
    },
    rotating() {
      const { isRotating, angleList, config, rotateAngle, index } = this;

      if (isRotating) return;

      this.isRotating = true;

      // 计算角度
      const angle =
        // 初始角度
        rotateAngle +
        // 多旋转的圈数
        config.circle * CIRCLE_ANGLE +
        // 奖项的角度
        angleList[index] -
        (rotateAngle % CIRCLE_ANGLE);
      // console.log(rotateAngle % CIRCLE_ANGLE);
      // console.log(angle, "angle");

      //旋转角度
      this.rotateAngle = angle;

      // 旋转结束后，允许再次触发
      setTimeout(() => {
        this.rotateOver();
      }, config.duration + 1000);
    },
    rotateOver() {
      //是否正在旋转归0
      this.isRotating = false;

      //拿到的哪个奖品
      this.prize = prizeList[this.index];

      console.log(this.prize, this.index);
    },
  },
};
</script>
<style scoped lang="less">
:deep .van-address-edit__buttons{
  .van-button--round{
    border-color: #FBC135;
    background-color: #FBC135;
    color:#F02209;
    font-weight: bold;

font-size: 16px;
  }
}
.van-popup--center {
  background: transparent;
  height: 362px;
  overflow: hidden;
  .popup-close{
    position: absolute;
    left: 50%;
    width: 33px ;
    height: 33px;
    z-index: 1;
    transform: translateX(-50%);
    bottom: 0px;
    img{
      width: 33px !important;

    }
  }
  .popup-text {
    position: absolute;
    font-size: 24px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #fef3b7;
    line-height: 38px;
    z-index: 1;
    left: 50%;
    top: 40px;
    text-align: center;
    transform: translateX(-50%);
  }
  .popup-button{
    bottom: 6px;
    position: absolute;
    z-index: 1;
    width: 164px;
    height: 45px;
    left: 50%;
    transform: translateX(-50%);
  }



  .popup-box {
    position: relative;
    width: 268px;
    height: 309px;
    img {
      position: absolute;
      width: 100%;
      object-fit: cover;
    }
  }
}

.container {
  font-family: PingFang SC;
  background: #ff7253;
  overflow: hidden;
}
header {
  margin: 10px auto;
  text-align: center;
  width: 203px;
  height: 60px;
  color: #fff;
  font-size: 14px;
  line-height: 28px;
  background: rgba(255, 255, 255, 0.14);
  border: 1px solid #ffffff;
  border-radius: 12px;
  div {
    font-size: 27px;
    font-weight: bold;
    color: #fef772;
    // line-height: 52px;
  }
}
.lucky-wheel {
  width: 100%;
  background: url("../assets/img/618bgred.png") no-repeat center bottom;
  background-size: 100%;
  padding-top: 20px;
}

.wheel-main {
  margin: 0 auto;
  position: relative;
  width: 295px;
  height: 295px;
}
.wheel-bg {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  background: url("../assets/img/draw_wheel.png") no-repeat center top;
  background-size: 100%;
  color: #fff;
}
.wheel-pointer {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 2;
  width: 85px;
  height: 85px;
  background: url("../assets/img/draw_btn.png") no-repeat center top;
  background-size: 100%;
  transform: translate3d(-50%, -50%, 0);
}
.wheel-bg div {
  text-align: center;
}
.prize-list {
  width: 100%;
  height: 100%;
  position: relative;
}
.prize-list .prize-item {
  position: absolute;
  width: 95px;
  height: 150px;
  top: 0;
  left: 50%;
  margin-left: -47.5px;
  transform-origin: 50% 100%;
}

.prize-pic img {
  width: 70px;
  height: 50px;
  margin-top: 20px;
  object-fit: cover;
}

.prize-type {
  font-size: 12px;
}
main {
  overflow: hidden;
  margin: 20px auto;
  width: 345px;
  // height: 355px;
  background: #ffffff;
  border-radius: 10px;
  padding: 0 20px 20px;
  box-sizing: border-box;
  .main-header {
    margin: 20px 0;
    display: flex;
    justify-content: center;
    font-size: 17px;
    font-weight: bold;
    color: #ff5f11;
    line-height: 14px;
    img {
      margin: 0 10px;
      width: 23px;
      object-fit: contain;
    }
  }
  .main-content {
    font-size: 14px;
    font-weight: 500;
    color: #1b1b1b;
    line-height: 20px;
    p {
      margin: 10px 0;
    }
  }
}
</style>

